import { SvgIcon, type SvgIconProps } from '@mui/material';

import ChevronLeftIcon from './ChevronLeft.svg';

export type TChevronDirection = 'left' | 'right' | 'up' | 'down';

const rotationByDirection: Record<TChevronDirection, number> = {
	left: 0,
	right: 180,
	up: 90,
	down: 270,
};

export interface IChevronIconProps
	extends Omit<SvgIconProps, 'component' | 'children'> {
	direction?: TChevronDirection;
}

export const ChevronIcon = ({
	direction = 'left',
	sx,
	...rest
}: IChevronIconProps) => {
	const rotation = rotationByDirection[direction];

	return (
		<SvgIcon
			component={ChevronLeftIcon}
			{...rest}
			sx={rotation ? { transform: `rotate(${rotation}deg)`, ...sx } : sx}
		/>
	);
};
